/* @ngInject */

function serverError($timeout) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function (scope, element, attrs, ctrl) {
      element.on('change keyup', function () {
        $timeout(function () {
          scope.$apply(function () {
            ctrl.$setValidity('validationError', true);
          });
        });
      });
    },
  };
}

export default serverError;
